import React, { useState } from 'react';

export type ToolTipProps = {
  tipText: string;
  xPosition: 'left' | 'right' | 'center';
  yPosition: 'above' | 'below';
  isInputIcon?: boolean;
};

const ToolTip: React.FC<ToolTipProps> = ({
  tipText,
  xPosition,
  yPosition,
  isInputIcon = false,
}: ToolTipProps) => {
  const [showToolTip, setShowToolTip] = useState(false);
  const yOuterTransform =
    yPosition === 'above' ? '-translate-y-1' : 'translate-y-5';
  const yInnerTransform = yPosition === 'above' ? '-translate-y-full' : '';
  const xOuterTransform =
    xPosition === 'left' ? 'translate-x-10' : '-translate-x-10';
  const xInnerTransform =
    xPosition === 'left' ? '-translate-x-full' : '-translate-x-1/2';

  const outerClassName = `z-50 transform ${yOuterTransform} ${
    xPosition !== 'center' ? xOuterTransform : ''
  }`;
  const innerClassName = `absolute transform ${yInnerTransform} ${
    xPosition !== 'right' ? xInnerTransform : ''
  } text-xs text-white bg-gray-600 opacity-90 rounded-md px-2 py-1 w-56`;

  const handleOnMouseEnter = (): void => {
    setShowToolTip(true);
  };
  const handleOnMouseLeave = (): void => {
    setShowToolTip(false);
  };

  return (
    <div className="relative float-right input-icon tooltip-input-icon">
      {showToolTip && (
        <div className={outerClassName}>
          <div className={innerClassName}>{tipText}</div>
        </div>
      )}
      <svg
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={
            isInputIcon
              ? 'checkout-panel-form-input-icon-color'
              : 'checkout-panel-icon-color'
          }
          d="M8.23944 5.24648V3.73239H6.76056V5.24648H8.23944ZM8.23944 11.2676V6.76056H6.76056V11.2676H8.23944ZM2.1831 2.21831C3.66198 0.739429 5.43426 0 7.5 0C9.56574 0 11.3322 0.733561 12.7993 2.2007C14.2664 3.66785 15 5.43426 15 7.5C15 9.56574 14.2664 11.3322 12.7993 12.7993C11.3322 14.2664 9.56574 15 7.5 15C5.43426 15 3.66785 14.2664 2.2007 12.7993C0.733561 11.3322 0 9.56574 0 7.5C0 5.43426 0.727692 3.67372 2.1831 2.21831Z"
        />
      </svg>
    </div>
  );
};

export default ToolTip;
